import React from 'react';
import { connect } from 'react-redux';
import { toggleSidebar } from '../../../utils/redux/actions';

/**
 * Export a component to render a list with element rendered in table. (e.g. atcive or done documents)
 */

const NavbarToggle = ({ dispatch }) => {
	const handleClick = () => dispatch(toggleSidebar());

	return (
		<nav className='nav align-items-center text-center'>
			<i
				className='pointer fas fa-bars d-md-none'
				onClick={handleClick}
				style={{ fontSize: 'x-large', minWidth: '3.75rem' }}
			/>
		</nav>
	);
};

/**
 * Define mapStateToProps and return an empty Object.
 * Necessary for hassle-free functioning of redux.
 */
const mapStateToProps = () => ({});

export default connect(mapStateToProps)(NavbarToggle); //Export component and connect it with redux.
